import { TrendingUp } from "lucide-react";

interface ResultsSectionProps {
  items: string[];
}

export const ResultsSection = ({ items }: ResultsSectionProps) => {
  if (!items || items.length === 0) return null;

  return (
    <div className="border-t pt-12 mt-12">
      <div className="flex items-center gap-3 mb-6">
        <TrendingUp className="w-8 h-8 text-accent" />
        <h2 className="text-3xl font-bold">Results You Can Expect</h2>
      </div>
      <div className="space-y-4">
        {items.map((item, index) => (
          <div key={index} className="flex items-start gap-3 p-4 rounded-lg bg-accent/5 border border-accent/20">
            <span className="text-2xl font-bold text-accent flex-shrink-0">→</span>
            <p className="text-lg text-foreground leading-relaxed">{item}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
